import { DialogActions, DialogTitle } from "@material-ui/core";
import React, { Component } from "react";

import { WorkspaceUserRole } from "common/interfaces";
import { getStaticUrl } from "js/config";
import AppController from "js/core/AppController";
import getLogger from "js/core/logger";
import {
    BeautifulDialog,
    DialogContent,
    ShowErrorDialog
} from "js/react/components/Dialogs/BaseDialog";
import { BlueButton, BlueOutlinedButton } from "js/react/components/UiComponents";
import FetchingClickShield from "js/react/components/FetchingClickShield";

const logger = getLogger();

export default class MemberAddedToWorkspaceDialog extends Component {
    state = {
        fetching: false
    };

    handleJoinTeam = async () => {
        const { notification: { id, event: { teamInviteUrl } } } = this.props;

        try {
            this.setState({ fetching: true });
            await AppController.notificationsService.markAsRead(id);
            window.open(teamInviteUrl, "_self");
        } catch (err) {
            logger.error(err, "[MemberAddedToWorkspaceDialog] AppController.notificationsService.markAsRead() failed", { id });

            ShowErrorDialog({
                error: "Error joining team",
                message: err.message
            });
        }
    }

    handleClose = async () => {
        const { closeDialog, notification: { id } } = this.props;

        try {
            this.setState({ fetching: true });
            await AppController.notificationsService.markAsRead(id);
        } catch (err) {
            logger.error(err, "[MemberAddedToWorkspaceDialog] AppController.notificationsService.markAsRead() failed", { id });
        }

        closeDialog();
    }

    render() {
        const { notification: { id, event: { triggeredByUser, teamName, toUserRole } } } = this.props;
        const { fetching } = this.state;

        return (
            <BeautifulDialog>
                <FetchingClickShield visible={fetching} backgroundColor="white" />
                <img style={{ width: 50, margin: "20px auto 0" }} src={getStaticUrl("/images/invite-icon.svg")} />
                <DialogTitle>Join the team!</DialogTitle>
                <DialogContent>
                    <p>{triggeredByUser.displayName} has invited you to join <span style={{ color: "#159bcd", fontWeight: 900 }}>{teamName}.</span></p>
                    <p>
                        {toUserRole === WorkspaceUserRole.OWNER && "You have been asked to join as an Owner, which means you'll have the ability to manage the team, team slides and theme."}
                        {toUserRole === WorkspaceUserRole.LIBRARIAN && "You have been asked to join as a Librarian, which means you'll have the ability to manage team slides and theme."}
                        {toUserRole === WorkspaceUserRole.MEMBER && "Now you can build decks together, faster. Keep everything in one place and everyone on brand with team slides and theme."}
                    </p>
                </DialogContent>
                <DialogActions>
                    <BlueOutlinedButton onClick={this.handleClose}>
                        Maybe Later
                    </BlueOutlinedButton>
                    <BlueButton onClick={this.handleJoinTeam}>
                        Join Now
                    </BlueButton>
                </DialogActions>
            </BeautifulDialog>
        );
    }
}
